export var Status;
(function (Status) {
    /** Insufficient permissions to get the status. */
    Status["UNKNOWN"] = "UNKNOWN";
    /** Member is hidden from site visitors and other site members. Member is returned only to Wix users. */
    Status["PRIVATE"] = "PRIVATE";
    /** Member is visible to everyone. */
    Status["PUBLIC"] = "PUBLIC";
})(Status || (Status = {}));
export var Scope;
(function (Scope) {
    Scope["UNKNOWN_SCOPE"] = "UNKNOWN_SCOPE";
    /** Service */
    Scope["SERVICE"] = "SERVICE";
    /** Owner */
    Scope["OWNER"] = "OWNER";
    /** Editor */
    Scope["EDITOR"] = "EDITOR";
    /** Writer */
    Scope["WRITER"] = "WRITER";
    /** Guest writer */
    Scope["GUEST_WRITER"] = "GUEST_WRITER";
    /** Open Blog writer */
    Scope["OPEN_BLOG_WRITER"] = "OPEN_BLOG_WRITER";
    /** User */
    Scope["USER"] = "USER";
    /** Guest */
    Scope["GUEST"] = "GUEST";
})(Scope || (Scope = {}));
export var ImportWarningType;
(function (ImportWarningType) {
    ImportWarningType["UNKNOWN"] = "UNKNOWN";
    ImportWarningType["BLOGS_MAIN_LANGUAGES_DIFFERENT"] = "BLOGS_MAIN_LANGUAGES_DIFFERENT";
    ImportWarningType["SOME_LANGUAGES_NOT_IMPORTED"] = "SOME_LANGUAGES_NOT_IMPORTED";
    ImportWarningType["IMPORTED_DIFFERING_LANGUAGES"] = "IMPORTED_DIFFERING_LANGUAGES";
    ImportWarningType["SOURCE_DESTINATION_LANGUAGE_NOTIFICATION"] = "SOURCE_DESTINATION_LANGUAGE_NOTIFICATION";
    ImportWarningType["SOURCE_BLOG_TOO_BIG"] = "SOURCE_BLOG_TOO_BIG";
    ImportWarningType["POST_LIMIT_REACHED"] = "POST_LIMIT_REACHED";
    ImportWarningType["CATEGORY_LIMIT_REACHED"] = "CATEGORY_LIMIT_REACHED";
    ImportWarningType["TAG_LIMIT_REACHED"] = "TAG_LIMIT_REACHED";
})(ImportWarningType || (ImportWarningType = {}));
export var ImportStatusStatus;
(function (ImportStatusStatus) {
    ImportStatusStatus["UNKNOWN"] = "UNKNOWN";
    ImportStatusStatus["STARTED"] = "STARTED";
    ImportStatusStatus["FAILED"] = "FAILED";
    ImportStatusStatus["DONE"] = "DONE";
    ImportStatusStatus["PARSING_URL"] = "PARSING_URL";
})(ImportStatusStatus || (ImportStatusStatus = {}));
export var Type;
(function (Type) {
    /** Undefined type. */
    Type["UNKNOWN"] = "UNKNOWN";
    /** Posts. */
    Type["POSTS"] = "POSTS";
    /** Categories. */
    Type["CATEGORIES"] = "CATEGORIES";
    /** Tags. */
    Type["TAGS"] = "TAGS";
})(Type || (Type = {}));
//# sourceMappingURL=types.impl.js.map